module.exports = __webpack_public_path__ + "img/img2.3d28ac14.jpg";